import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Header from "../components/Header";
import Menu from "../components/Menu";
import Form from "../../../../components/shared/Form";
import Expiration from "./Expiration";
import OpenShift from "./OpenShift";
import { usePreferenceMutation } from "../api/usePreferenceMutation";
import { useCompanyPreferences } from "../hooks/usePreferences";

const options: string[] = ["expiration", "open-shift"];

function Request() {
    const [option, setOption] = useState("expiration");
    const { mutate, isPending } = usePreferenceMutation("company", "requests");
    const request = useCompanyPreferences("requests");
    const form = useForm({
        defaultValues: request,
    });
    const { reset } = form;
    const onFinish = (value: typeof request) => mutate({ ...request, ...value });

    const content = useMemo(() => {
        switch (option) {
            default:
            case "expiration":
                return <Expiration />;
            case "open-shift":
                return <OpenShift />;
        }
    }, [option]);

    useEffect(() => {
        if (request !== undefined) reset(request);
    }, [reset, request]);

    return (
        <div className="tw-p-5 tw-h-full tw-bg-white tw-rounded-lg">
            <Form className="tw-h-full" form={form} onFinish={onFinish}>
                <Header name="request" isLoading={isPending} />
                <Menu
                    options={options}
                    option={option}
                    setOption={setOption}
                />
                {content}
            </Form>
        </div>
    );
}

export default Request;
